import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

export interface LayoutProps {
  children: React.ReactNode
  onNavigateToAccount?: () => void
  onNavigateToCart?: () => void
}

export default function Layout({ children, onNavigateToAccount, onNavigateToCart }: LayoutProps) {
  const location = useLocation()

  const isAccountPage = location.pathname.startsWith('/account')
  const isCheckoutPage = location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')

  return (
    <div className="w-dvw h-dvh overflow-y-auto flex flex-col font-sans bg-background text-foreground">
      <Header
        onNavigateToAccount={onNavigateToAccount}
        onNavigateToCart={onNavigateToCart}
      />
      <main className={`w-full flex-1 flex flex-col ${isAccountPage || isCheckoutPage ? '' : 'items-center p-5 md:p-8'}`}>
        {children}
      </main>
      <Footer />
    </div>
  )
}
